import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { DateTime } from 'luxon';

import MySubscriptionSkeleton from './mySubscriptionSkeleton';

import {
  getAddons,
  getCustomerId,
  getCustomerSubscriptionById,
  getPlanDetails,
  updateSubscription,
  openPauseModal,
  closePauseModal,
  openCancelModal,
  closeCancelModal,
  pauseSubscription,
  cancelSchedulePause,
  cancelSubscription,
  getCancelQuestions,
  saveCancelQuestions,
  setCurrency,
  setPeriod,
  resetMySubscriptions,
  updateSubscriptionTenant,
  resetMySubscription,
  resetChangeSubscription
} from "../../../store/actions";
import { getCustomer } from '../../../utils/helpers';

import { camelToSnake } from "../../../utils/helpers";

import Alert from '../../../utils/components/Alerts';
import MarquetCards from '../../../utils/components/MarquetCards';
import Loader from '../../../assets/components/loader';
import CheckIcon from '../../../assets/svg/checkIcon';

import PauseModal from './pauseModal';
import CancelModal from './cancelModal';

const MySubscription = () => {

  const customerId = getCustomer();
  const param = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const subscriptionInfo = useSelector((state) => state.mySubscription);

  const [billingCicle, setBillingCicle] = useState("")
  const [subscriptionItems, setSubscriptionItems] = useState([])
  const [planItem, setPlanItem] = useState({})

  const [subscription, setSubscription] = useState({})

  const [addons, setAddons] = useState([]);
  const [totals, setTotals] = useState({
    subTotal: "",
    tax: "",
    total: ""
  });
  const [newTotals, setNewTotals] = useState({
    subTotal: "",
    tax: "",
    total: ""
  });

  const [cancelForm, setCancelForm] = useState([])

  useEffect(() => {
    if (customerId === "") {
      navigate('/')
    }
  }, [])

  useEffect(() => {
    if (!subscriptionInfo.questionsObtained){
      dispatch(getCancelQuestions(1));
    }else{
      let questions = [];
      subscriptionInfo.questions.map((question) => {
        if (question && question.options && question.options.length > 0){
          let optionsAnswers = []
          question.options.map((option) => {
            if (question.questionTypeName === "Radio") {
              optionsAnswers.push({
                id: option.id,
                selected: false
              })
            } else if (question.questionTypeName === "Checkbox"){
              optionsAnswers.push({
                id: option.option,
                selected: false
              })
            }
          })
          questions.push({
            questionId : question.questionId,
            options : optionsAnswers
          })
        }else{
          questions.push({
            questionId: question.questionId,
            value: ""
          })
        }
      })
      setCancelForm(questions)
    }
  }, [subscriptionInfo.questionsObtained])

  useEffect(() => {
    if (!subscriptionInfo.subscriptionObtained) {
      dispatch(getCustomerSubscriptionById(param.subscriptionId));
    } else if (subscriptionInfo.subscription.id !== param.subscriptionId){
      dispatch(resetMySubscription());
    }else if(subscriptionInfo.subscriptionObtained){
      setSubscription(subscriptionInfo.subscription);
      if (subscriptionInfo.subscription && subscriptionInfo.subscription.subscriptionItems && subscriptionInfo.subscription.subscriptionItems.length){
        setPlanItem(subscriptionInfo.subscription.subscriptionItems[0]);
      }
      if (!subscriptionInfo.addonsObtained) {
        setBillingCicle(subscriptionInfo.subscription.billingPeriodUnit);
        let data = {
          currency: subscriptionInfo.subscription.currencyCode,
          period: subscriptionInfo.subscription.billingPeriodUnit.toLowerCase().replace("ly", "")
        }
        dispatch(setCurrency(subscriptionInfo.subscription.currencyCode));
        dispatch(setPeriod(subscriptionInfo.subscription.billingPeriodUnit.toLowerCase()));
        dispatch(getAddons(data));
      }
    }
  }, [subscriptionInfo.subscriptionObtained])

  useEffect(()=>{
    if (!subscriptionInfo.customerObtained){
      dispatch(getCustomerId());
    }
  }, [subscriptionInfo.customerObtained])

  useEffect(() => {
    if (subscriptionInfo.customerObtained && subscriptionInfo.subscriptionObtained){
      let subTotal = 0;
      let tax = 0
      let total = 0
      if (subscriptionInfo.subscription && subscriptionInfo.subscription.subscriptionItems && subscriptionInfo.subscription.subscriptionItems.length > 0) {
        subscriptionInfo.subscription.subscriptionItems.map((item) => {
          subTotal += (item.quantity * item.unitPrice)
          total += (item.quantity * item.unitPrice)
        })
        if (subscriptionInfo.billingCountry === "CA") {
          tax = (subTotal * 0.13)
          total += (subTotal * 0.13)
        }
        setTotals({
          subTotal: (subTotal / 100).toLocaleString('en-US', { style: 'currency', currency: subscriptionInfo.subscription.currencyCode }),
          tax: (tax / 100).toLocaleString('en-US', { style: 'currency', currency: subscriptionInfo.subscription.currencyCode }),
          total: (total / 100).toLocaleString('en-US', { style: 'currency', currency: subscriptionInfo.subscription.currencyCode })
        })
      }
    }
  }, [subscriptionInfo.customerObtained && subscriptionInfo.subscriptionObtained])

  useEffect(() => {
    if (subscriptionInfo.addonsObtained && subscriptionInfo.subscriptionObtained && subscriptionInfo.addons){
      let subscriptionItems = {}
      subscriptionInfo.addons.map((addon) => {
        subscriptionItems[`${addon.id}`] = 0;
        if (subscription && subscription.subscriptionItems && subscription.subscriptionItems.length > 0){
          for (let i = 0; i < subscription.subscriptionItems.length; i++) {
            if (subscription.subscriptionItems[i].itemPriceId === addon.id) {
              subscriptionItems[`${addon.id}`] = subscription.subscriptionItems[i].quantity;
            }
          }
        }
      })
      setAddons(subscriptionInfo.addons);
      setSubscriptionItems(subscriptionItems);
    }
  }, [subscriptionInfo.addonsObtained])

  useEffect(() => {
    if (planItem && planItem.itemPriceId){
      dispatch(getPlanDetails(planItem.itemPriceId.split("-")[0]));
    }
  }, [planItem])

  function formatDate(timestamp) {
    if (typeof (timestamp) === "number"){
      const date = DateTime.fromSeconds(timestamp);
      const formattedDate = date.toFormat("MMMM dd, yyyy");
      return formattedDate;
    }else{
      return ""
    }
  }

  function changeAddonsValue(ev) {
    let value = parseInt(ev.target.value)
    if (value < 0) {
      value = value * -1
    } else if (value > 999) {
      value = 999
    }
    setSubscriptionItems({
      ...subscriptionItems,
      [ev.target.name]: parseInt(value)
    });
  }

  useEffect(() => {
    if (Object.keys(subscriptionInfo.subscriptionSelected).length > 0){
      let newPlan = {
        amount: subscriptionInfo.subscriptionSelected.price,
        freeQuantity: 0,
        itemPriceId: subscriptionInfo.subscriptionSelected.id,
        itemType: "plan",
        object: "subscription_item",
        quantity: 1,
        unitPrice: subscriptionInfo.subscriptionSelected.price,
      }
      setPlanItem(newPlan)
    }
  }, [subscriptionInfo.subscriptionSelected])

  //This is used to calculate the total and sub-total
  useEffect(() => {
    if (planItem && planItem.unitPrice && subscriptionInfo && subscriptionInfo.loadedFirstTime && subscriptionInfo.subscription && subscriptionInfo.subscription.currencyCode){
      let planTotal = 0;
      let addonsTotal = 0;
      let subTotal = 0;
      let tax = 0;
      let total = 0;
      planTotal = planItem?.unitPrice || 0;
      if (subscriptionInfo && subscriptionInfo.addons && subscriptionInfo.addons.length) {
        subscriptionInfo.addons.map((it, i) => {
          if (subscriptionItems[`${it.id}`] > 0) {
            addonsTotal += (subscriptionItems[`${it.id}`] * it.price)
          }
        })
      }
      subTotal = planTotal + addonsTotal
      if (subscriptionInfo.billingCountry === "CA") {
        tax = (subTotal * 0.13);
        total = subTotal + tax;
      }else{
        total = subTotal;
      }
      setNewTotals({
        subTotal: (subTotal / 100).toLocaleString('en-US', { style: 'currency', currency: subscriptionInfo.subscription.currencyCode }),
        tax: (tax / 100).toLocaleString('en-US', { style: 'currency', currency: subscriptionInfo.subscription.currencyCode }),
        total: (total / 100).toLocaleString('en-US', { style: 'currency', currency: subscriptionInfo.subscription.currencyCode })
      })
    }
  },[subscriptionItems, subscriptionInfo.loadedFirstTime, planItem ])

  function saveSubscriptionPlan(ev) {
    ev.preventDefault();
    let subscription = []
    subscription.push(planItem);
    subscriptionInfo && subscriptionInfo.planDetails && subscriptionInfo.planDetails.hasAddons === true && addons.map((addon) =>{
      if (subscriptionItems.hasOwnProperty(`${addon.id}`)){
        if (subscriptionItems[`${addon.id}`] > 0){
          subscription.push({
            itemPriceId: addon.id,
            itemType:"addon",
            object:"subscription_item",
            quantity: subscriptionItems[`${addon.id}`],
            unitPrice: addon.price,
          })
        }
      }
    })
    dispatch(updateSubscription({subscriptionId: subscriptionInfo.subscription.id, subscriptionItems: camelToSnake(subscription) }))
  }

  const pauseCurrentSubscription = (ev) => {
    ev.preventDefault();
    dispatch(resetMySubscriptions());
    dispatch(pauseSubscription(subscriptionInfo.subscription.id))
  }

  const revertPauseSubscription = (ev) => {
    ev.preventDefault();
    dispatch(resetMySubscriptions());
    dispatch(cancelSchedulePause(subscriptionInfo.subscription.id))
  }

  const handleInputChange = (ev) => {
    let index = ev.target.name.split("-")
    let answers = [...cancelForm];
    if (index.length === 1) {
      answers[parseInt(index[0])].value = ev.target.value;
    } else if (index.length === 2){
      if (parseInt(index[0]) === 0){
        answers[parseInt(index[0])].options[parseInt(index[1])].selected = !answers[parseInt(index[0])].options[parseInt(index[1])].selected;
      }else{
        answers[parseInt(index[0])].options.map((it, i) => {
          if (i === parseInt(index[1])){
            it.selected = true;
          }else{
            it.selected = false;
          }
        })
      }
    }
    setCancelForm(answers)
  }

  const sendCancelQuestions = (ev) =>{
    ev.preventDefault();
    let answers = []
    cancelForm.map((item) => {
      if(item.options){
        item.options.map((option)=>{
          if(option.selected){
            answers.push({
              chargebee_purchase_id: subscriptionInfo.subscription.id,
              question_id: item.questionId,
              value: option.selected
            })
          }
        })
      }else{
        answers.push({
          chargebee_purchase_id: subscriptionInfo.subscription.id,
          question_id : item.questionId,
          value : item.value
        })
      }
    })
    dispatch(saveCancelQuestions({answers: answers}));
  }

  const cancelThisSubscription = (ev) =>{
    ev.preventDefault();
    dispatch(cancelSubscription(subscriptionInfo.subscription.id));
    dispatch(resetMySubscriptions());
  }

  useEffect(() => {
    if (subscriptionInfo.tenantUpdated){
      navigate(`/mySubscriptions`);
    }
  }, [subscriptionInfo.tenantUpdated])

  useEffect(() => {
    if (subscriptionInfo.subscriptionCanceled){
      let data = {
        chargeBeePurchaseId: subscriptionInfo.subscription.id,
        status: "cancelled"
      }
      dispatch(resetMySubscriptions());
      dispatch(updateSubscriptionTenant(data));
    }
  }, [subscriptionInfo.subscriptionCanceled])

  if (!subscriptionInfo.loadedFirstTime) {
    return (
      <MySubscriptionSkeleton/>
    )
  }

  window.addEventListener('popstate', () => {
    dispatch(closePauseModal());
    dispatch(closeCancelModal());
  });

  return (
    <>
      <div className="subscription--view">
        <div className="subscription--management">
          <div onClick={ev => {
            dispatch(resetChangeSubscription());
            navigate(`/changeSubscription/${param.subscriptionId}`) }}>
            Change My Subscription
          </div>
          {subscriptionInfo.subscription.pauseDate ?
            <div onClick={ev => revertPauseSubscription(ev)}>
              {subscriptionInfo.statusChanging && <Loader size="xs" />}
              Cancel Schedule Pause
            </div> :
            subscriptionInfo.subscription.status === "pause" ?
              <div onClick={ev => { dispatch(openPauseModal()) }}>
                Resume My Subscription
              </div> :
              <div onClick={ev => { dispatch(openPauseModal()) }}>
                Pause My Subscription
              </div>
          }
          <div onClick={ev => {
            dispatch(openCancelModal());
          }}>
            Cancel My Subscription
          </div>
        </div>
        <div className="plan--side">
          <MarquetCards classStyles={"subscription--card"}>
            <div className="top--card--title">
              <span>Your Current Plan</span>
            </div>
            <div>
              <h4 className="marquet--colored">
                {`${formatDate(subscription.currentTermStart)} - ${formatDate(subscription.currentTermEnd)}`}
              </h4>
            </div>
            <div>
              <h5>
                {`Next Invoice: ${formatDate(subscription.currentTermEnd)}`}
              </h5>
            </div>
            <div>
              {subscription && subscription.subscriptionItems && subscription.subscriptionItems.length > 0 &&
                (<h3>
                {`${subscription.subscriptionItems[0].itemPriceId.split("-")[0]}`}
                </h3>)
              }
            </div>
            <div className="item--price">
              <div>
                <h4>Subscription Fee</h4>
                <i></i>
                {subscription && subscription.subscriptionItems && subscription.subscriptionItems.length > 0 &&
                  (<span>
                    {`${(subscription.subscriptionItems[0].unitPrice / 100).toLocaleString('en-US', { style: 'currency', currency: subscription.currencyCode })}`}
                  </span>)
                }
              </div>
              <div className="subscription--frecuency">
                {`Billed ${billingCicle}`}
              </div>
            </div>
            <div className="subscription--details">
              <div>
                <h4>Add-ons</h4>
              </div>
              {subscription && subscription.subscriptionItems && subscription.subscriptionItems.length > 1 && subscription.subscriptionItems.map((it) => (
                it.itemType === "addon" && addons.map((jt, j) => {
                  if (it.itemPriceId === jt.id) {
                    return (
                      <div key={j} className="item--price">
                        <div>
                          <h5>{`${it.quantity} ${jt.metadata.unit}`}</h5>
                          <i></i>
                          <span>
                            {`${((it.quantity * it.unitPrice) / 100).toLocaleString('en-US', { style: 'currency', currency: subscriptionInfo.subscription.currencyCode })}`}
                          </span>
                        </div>
                        <div className="subscription--frecuency">
                          {`Billed ${billingCicle}`}
                        </div>
                      </div>
                    )
                  }
                })
              ))
              }
              <div className="item--price">
                <div>
                  <h4>SUB-TOTAL</h4>
                  <i></i>
                  <span>
                    {totals.subTotal}
                  </span>
                </div>
              </div>
              <div className="item--price">
                <div>
                  <h4>TAX</h4>
                  <i></i>
                  <span>
                    {totals.tax}
                  </span>
                </div>
              </div>
              <div className="item--price">
                <div>
                  <h4>TOTAL</h4>
                  <i></i>
                  <span>
                    {totals.total}
                  </span>
                </div>
              </div>
            </div>
          </MarquetCards>
        </div>
        <div className="addons--side">
          <div className="plan--addons">
            <h2>
              Add-ons Available
            </h2>
            <div className="addons--container">
              {(!addons || addons.length === 0 || subscriptionInfo.planDetails.hasAddons === false) && <Alert type={"marquet"}>
                <p>No addons Available</p>
              </Alert>
              }
              {subscriptionInfo && subscriptionInfo.planDetails && subscriptionInfo.planDetails.hasAddons === true && addons && addons.length > 0 && addons.map((it, i) => (
                <div key={i}>
                  <div><CheckIcon /></div>
                  <div>
                    <div className="addon--name">{it.externalName}</div>
                    <div className="addon--feature">
                      <span>{`${(it.price / 100).toLocaleString('en-US', { style: 'currency', currency: it.currencyCode })}`}</span>
                      {`per ${it.metadata && it.metadata.unit ? it.metadata.unit : ""}/${it.metadata && it.metadata.periodUnit ? it.metadata.periodUnit : ""}`}
                    </div>
                  </div>
                  <div className="addon--quantity">
                    <label>Qty</label>
                    <input
                      type="number"
                      name={it.id}
                      value={subscriptionItems && subscriptionItems[`${it.id}`] ? subscriptionItems[`${it.id}`] : 0}
                      onChange={ev => changeAddonsValue(ev)}
                      min={0}
                      max={999}
                      step={1} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="subtotal">
            <div className="subtotal--price">
              {Object.keys(planItem).length > 0 &&
                (
                  <>
                    <h3>
                    {`Marquet Cloud ${planItem.itemPriceId.split("-")[0]}`}
                    </h3>
                    <div>
                    {`${(planItem.unitPrice / 100).toLocaleString('en-US', { style: 'currency', currency: subscription.currencyCode })}`}
                    </div>
                  </>
                )
              }
            </div>
            <div className="addons--subtotal">
              <h3>My addons</h3>
              {addons && addons.length > 0 && addons.map((it, i) => {
                if (subscriptionItems[`${it.id}`] > 0){
                  return(
                    <div key={i}>
                      <div>
                        {`${subscriptionItems[`${it.id}`]} ${it.externalName}`}
                      </div>
                      <div>
                        {`${((subscriptionItems[`${it.id}`] * it.price) / 100).toLocaleString('en-US', { style: 'currency', currency: it.currencyCode })}`}
                      </div>
                    </div>
                  )
                }
              })}
            </div>
            <div className="subtotal--price">
              <h3>Sub Total</h3>
              <div>
                {newTotals.subTotal}
              </div>
            </div>
            <div className="taxes">
              <h3>Tax</h3>
              <div>
                {newTotals.tax}
              </div>
            </div>
            <div className="total--price">
              <h2>Total</h2>
              <div>
                {newTotals.total}
              </div>
            </div>
          </div>
        </div>
        <div className="submit--region">
          <button
            onClick={ev => saveSubscriptionPlan(ev)}
            className="custom--button custom--button--marquet">
            Update Subscription
            {subscriptionInfo.loading && <Loader size="xs" />}
          </button>
        </div>
      </div>
      {subscriptionInfo.pauseModalOpen &&
        <PauseModal
        changeModalState = {ev => dispatch(closePauseModal())}
        loading={subscriptionInfo.modalLoading}
        onSave={pauseCurrentSubscription}
        />
      }
      {subscriptionInfo.cancelModalOpen &&
        <CancelModal
        changeModalState = {ev => dispatch(closeCancelModal())}
        handleInputChange={ev => handleInputChange(ev)}
        loading={subscriptionInfo.modalLoading}
        cancelForm={cancelForm}
        questions={subscriptionInfo.questions}
        cancelStep={subscriptionInfo.cancelStep}
        onSave={subscriptionInfo.cancelStep === 1? ev => sendCancelQuestions(ev) : ev => cancelThisSubscription(ev)}
        />
      }
    </>
  )
}

export default MySubscription;